export default __webpack_public_path__ + "static/media/evreux8.10d56e70.jpg";